export class Workroom {
    constructor() {

    }

    init() {
        $(".add-folder").click(function () {
            if ($(this).parent().hasClass("add-folder-holder")) {
                $("#add-folder-foldername").val($("#subfolder-name").val());
                $("#add-folder-submit").click();
            } else {
                $(this).parent().addClass("add-folder-holder");
            }
        });

        $(".add-file-btn").click(function () {
            $("#file-input").click();
        });

        $(".expand-button").click(function(event) {

            var $this = $(event.target);
            var parent = $this.closest('.group-header');

            parent.toggleClass("expanded");
        });

        $(function() {

            $(".panel-collapse").each(function () {
                if ($(this).hasClass("show")) {

                    var headerGroup = $(this).siblings('.group-header');
                    console.log(headerGroup);
                    headerGroup.addClass("expanded");
                }
            });           
        });
      

        $(".work-room-popup").click(function () {
            const folderName = $(this).siblings("h3").text();
            const isLastLevel = $(this).siblings("input").attr("data-is-last-level");
            const modal = $('#workroom-modal');

            modal.find(".add-folder-holder").removeClass("add-folder-holder");
            modal.find(".modal-title").html(`Mapp: ${folderName}`);

            $("#file-input-folder-name").val(folderName.trim());
            $("#add-folder-parentname").val(folderName.trim());
            $("#add-folder-foldername").val("");
            modal.find(".add-folder").show();
            if (isLastLevel === "True") {
                modal.find(".add-folder").hide();
            }
            modal.modal();
        });
    }
}


// WEBPACK FOOTER //
// ./frontend/js/components/ost.workroom.js